export const BLOG_CATEGORIES = ["Entrepreneurship", "Startups", "Business", "Technology", "AI", "Marketing", "Finance", "Branding", "E-commerce", "India Growth"];
export const FAQ_CATEGORIES = ["LaunchLab", "Startups", "Registrations", "Certifications", "Technology", "Projects", "Pricing", "Careers", "General"];
export const EVENT_CATEGORIES = ["Startup Events", "Workshops", "Seminars", "Launches", "Networking", "Founder Programs", "Innovation Events"];
export const NEWS_CATEGORIES = ["Announcements", "Projects", "Partnerships", "Milestones", "Product Launches", "Ecosystem"];
export const DEPARTMENTS = ["Strategy", "Technology", "Design", "Marketing", "Operations", "Sales", "Finance", "General"];

export const MODULES = {
  posts: {
    title: "Blog Posts",
    singular: "Post",
    endpoint: "/admin/posts",
    searchKeys: ["title", "category", "author"],
    listTitle: (i) => i.title,
    listSub: (i) => `${i.category} · ${i.author}`,
    imageKey: "image",
    fields: [
      { key: "title", label: "Title", type: "text", required: true },
      { key: "category", label: "Category", type: "select", options: BLOG_CATEGORIES },
      { key: "author", label: "Author", type: "text", default: "LaunchLab" },
      { key: "excerpt", label: "Short Description", type: "textarea", rows: 2 },
      { key: "content", label: "Full Article", type: "textarea", rows: 9 },
      { key: "image", label: "Featured Image", type: "image", imageSize: [1200, 630] },
      { key: "tags", label: "Tags (comma separated)", type: "text" },
      { key: "seo_title", label: "SEO Title", type: "text" },
      { key: "seo_description", label: "SEO Description", type: "textarea", rows: 2 },
      { key: "published", label: "Published", type: "switch", default: true },
    ],
  },
  news: {
    title: "News",
    singular: "News Item",
    endpoint: "/admin/news",
    searchKeys: ["headline", "category"],
    listTitle: (i) => i.headline,
    listSub: (i) => `${i.category} · ${i.date || ""}`,
    imageKey: "image",
    fields: [
      { key: "headline", label: "Headline", type: "text", required: true },
      { key: "date", label: "Date", type: "date" },
      { key: "category", label: "Category", type: "select", options: NEWS_CATEGORIES },
      { key: "summary", label: "Summary", type: "textarea", rows: 2 },
      { key: "content", label: "Full Content", type: "textarea", rows: 7 },
      { key: "image", label: "Image", type: "image" },
      { key: "external_link", label: "External Link (optional)", type: "text" },
      { key: "published", label: "Published", type: "switch", default: true },
    ],
  },
  jobs: {
    title: "Careers",
    singular: "Job",
    endpoint: "/admin/jobs",
    searchKeys: ["title", "department", "location"],
    listTitle: (i) => i.title,
    listSub: (i) => `${i.department} · ${i.location} · ${i.employment_type}`,
    badge: (i) => (i.status === "open" ? { text: "OPEN", cls: "border-[#00E676]/40 text-[#00E676]" } : { text: "CLOSED", cls: "border-red-500/40 text-red-400" }),
    fields: [
      { key: "title", label: "Job Title", type: "text", required: true },
      { key: "department", label: "Department", type: "select", options: DEPARTMENTS },
      { key: "location", label: "Location", type: "text", default: "Hyderabad" },
      { key: "employment_type", label: "Employment Type", type: "select", options: ["Full-time", "Part-time", "Contract", "Internship"] },
      { key: "experience", label: "Experience", type: "text" },
      { key: "description", label: "Job Description", type: "textarea", rows: 3 },
      { key: "responsibilities", label: "Responsibilities (one per line)", type: "textarea", rows: 4 },
      { key: "requirements", label: "Requirements (one per line)", type: "textarea", rows: 4 },
      { key: "skills", label: "Skills (comma separated)", type: "text" },
      { key: "status", label: "Status", type: "select", options: ["open", "closed"], default: "open" },
      { key: "display_order", label: "Display Order", type: "number", default: 0 },
      { key: "published", label: "Published", type: "switch", default: true },
    ],
  },
  testimonials: {
    title: "Testimonials",
    singular: "Testimonial",
    endpoint: "/admin/testimonials",
    searchKeys: ["name", "company"],
    listTitle: (i) => i.name,
    listSub: (i) => `${i.designation || ""} ${i.company ? "· " + i.company : ""} · ${"★".repeat(Math.max(1, Math.min(5, i.rating || 5)))}`,
    imageKey: "photo",
    fields: [
      { key: "name", label: "Person Name", type: "text", required: true },
      { key: "designation", label: "Designation", type: "text" },
      { key: "company", label: "Company", type: "text" },
      { key: "photo", label: "Photo", type: "image", imageSize: [600, 600] },
      { key: "text", label: "Testimonial", type: "textarea", rows: 4, required: true },
      { key: "rating", label: "Rating (1–5)", type: "number", default: 5 },
      { key: "category", label: "Category", type: "text", default: "General" },
      { key: "display_order", label: "Display Order", type: "number", default: 0 },
      { key: "published", label: "Published", type: "switch", default: true },
    ],
  },
  pricing: {
    title: "Pricing Packages",
    singular: "Package",
    endpoint: "/admin/pricing",
    searchKeys: ["name"],
    listTitle: (i) => i.name,
    listSub: (i) => (i.price ? `${i.price} · ${i.billing_type}` : "Contact Us (custom pricing)"),
    fields: [
      { key: "name", label: "Package Name", type: "text", required: true },
      { key: "description", label: "Description", type: "textarea", rows: 2 },
      { key: "price", label: "Price (leave blank for Contact Us)", type: "text" },
      { key: "billing_type", label: "Billing Type", type: "select", options: ["one-time", "monthly", "yearly", "custom"] },
      { key: "features", label: "Features (one per line)", type: "textarea", rows: 6 },
      { key: "cta_label", label: "CTA Label", type: "text", default: "Contact Us" },
      { key: "display_order", label: "Display Order", type: "number", default: 0 },
      { key: "published", label: "Active", type: "switch", default: true },
    ],
  },
  faqs: {
    title: "FAQs",
    singular: "FAQ",
    endpoint: "/admin/faqs",
    searchKeys: ["question", "category"],
    listTitle: (i) => i.question,
    listSub: (i) => i.category,
    fields: [
      { key: "question", label: "Question", type: "text", required: true },
      { key: "answer", label: "Answer", type: "textarea", rows: 5, required: true },
      { key: "category", label: "Category", type: "select", options: FAQ_CATEGORIES },
      { key: "display_order", label: "Display Order", type: "number", default: 0 },
      { key: "published", label: "Published", type: "switch", default: true },
    ],
  },
  team: {
    title: "Team Members",
    singular: "Team Member",
    endpoint: "/admin/team",
    searchKeys: ["name", "designation"],
    listTitle: (i) => i.name,
    listSub: (i) => i.designation,
    imageKey: "photo",
    fields: [
      { key: "name", label: "Name", type: "text", required: true },
      { key: "designation", label: "Designation", type: "text" },
      { key: "bio", label: "Short Biography", type: "textarea", rows: 3 },
      { key: "expertise", label: "Expertise (comma separated)", type: "text" },
      { key: "photo", label: "Photo", type: "image", imageSize: [600, 600] },
      { key: "linkedin", label: "LinkedIn URL", type: "text" },
      { key: "display_order", label: "Display Order", type: "number", default: 0 },
      { key: "published", label: "Active", type: "switch", default: true },
    ],
  },
  events: {
    title: "Events",
    singular: "Event",
    endpoint: "/admin/events",
    searchKeys: ["name", "category", "venue"],
    listTitle: (i) => i.name,
    listSub: (i) => `${i.date || ""} · ${i.venue || ""}`,
    imageKey: "image",
    badge: (i) =>
      i.status === "completed"
        ? { text: "COMPLETED", cls: "border-slate-500/40 text-slate-500" }
        : { text: (i.status || "upcoming").toUpperCase(), cls: "border-[#00E676]/40 text-[#00E676]" },
    fields: [
      { key: "name", label: "Event Name", type: "text", required: true },
      { key: "date", label: "Date", type: "date" },
      { key: "time", label: "Time", type: "text" },
      { key: "venue", label: "Venue", type: "text" },
      { key: "address", label: "Address", type: "text" },
      { key: "category", label: "Category", type: "select", options: EVENT_CATEGORIES },
      { key: "status", label: "Status", type: "select", options: ["upcoming", "ongoing", "completed"], default: "upcoming" },
      { key: "description", label: "Description", type: "textarea", rows: 4 },
      { key: "image", label: "Event Image", type: "image" },
      { key: "gallery", label: "Gallery (one image URL per line)", type: "textarea", rows: 3 },
      { key: "registration_link", label: "Registration Link", type: "text" },
      { key: "published", label: "Published", type: "switch", default: true },
    ],
  },
  regcategories: {
    title: "Registrations Content",
    singular: "Registration Category",
    endpoint: "/admin/regcategories",
    searchKeys: ["title", "tagline"],
    listTitle: (i) => i.title,
    listSub: (i) => i.tagline || "",
    imageKey: "image",
    fields: [
      { key: "num", label: "Number (e.g. 11)", type: "text" },
      { key: "title", label: "Title", type: "text", required: true },
      { key: "tagline", label: "Tagline", type: "text" },
      { key: "desc", label: "Short Description", type: "textarea", rows: 2 },
      { key: "detail", label: "Full Detail", type: "textarea", rows: 4 },
      { key: "bullets", label: "Items (one per line)", type: "textarea", rows: 5 },
      { key: "note", label: "Compliance Note", type: "textarea", rows: 2 },
      { key: "image", label: "Image", type: "image" },
      { key: "display_order", label: "Display Order", type: "number", default: 0 },
      { key: "published", label: "Published", type: "switch", default: true },
    ],
  },
};
